import { render, staticRenderFns } from "./AssetableLink.vue?vue&type=template&id=14d56a3e"
import script from "./AssetableLink.vue?vue&type=script&lang=js"
export * from "./AssetableLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports